import React, { useEffect, useState } from 'react';
import AppointmentForm from '../../components/AppointmentForm';
import HomeBanner from '../../components/HomeBanner';
import ClientReview from '../../components/ClientReview';
import Certification from '../../components/Certification';
import PersonalizedSection from '../../components/PersonalizedSection';
import PersonalizedCarausel from '../../components/PersonalizedCarausel';
import PersonalizedNutrition from '../../components/PersonalizedNutrition';
import Explore from '../../components/Explore';
import { getSeoByUrl } from '../../api/api';
import SchemaMarkup from '../../components/SchemaMarkup';
import { Helmet } from "react-helmet-async";
import HomePopupForm from '../../components/HomePopupForm';

const Home = ({ appointmentRef }) => {

  const [seoData, setSeoData] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [hasPopupBeenShown, setHasPopupBeenShown] = useState(() => {
    return localStorage.getItem('popupShown') === 'true';
  })
  useEffect(() => {
    if (!hasPopupBeenShown) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem('popupShown', 'true');
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, [hasPopupBeenShown]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("home");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {seoData.metaTitle || "Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || ""}
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/"}
        />
      </Helmet>

      <HomePopupForm isOpen={showPopup} onClose={handleClosePopup} />

      <SchemaMarkup />
      <HomeBanner />
      <PersonalizedSection />
      <PersonalizedCarausel />
      <PersonalizedNutrition />
      <Explore />
      <Certification />
      <ClientReview />
      <div ref={appointmentRef}>
        <AppointmentForm />
      </div>
    </>
  );
};

export default Home;